export const AppConstants = {
  // https://api.puppysbakery.com/
  // https://testapipuppys.technogenesis.in/

  SERVER_CONFIG: {
    DEVELOPMENT: '',
    STAGING: 'https://puppysbakery-api.technogenesis.in',
    PRODUCTION: 'https://api.puppysbakery.com',
    LOCAL: 'http://localhost:8080',
    USE_URL: 'STAGING',
    IMG_URL: '',
    DOMAIN: 'https://puppysbakery.com/#',
    localUrl: 'https://disagree-ouch-footpad.ngrok-free.dev',
    // localUrl: 'https://testapi.puppysbakery.com',
    localDev:
      /^(https?:\/\/)?(www\.)?testpuppysbakery\.technogenesis\.in(?:\/.*)?$/,
    stageDev: /^(https?:\/\/)?(www\.)?puppysbakery\.com(?:\/.*)?$/,
    localMob:
      /^(https?:\/\/)?(www\.)?mblpuppysbakery\.technogenesis\.in(?:\/.*)?$/,
    stageMob: /^(https?:\/\/)?(www\.)?m\.puppysbakery\.com(?:\/.*)?$/,
  },
};
